"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { IntercomProvider as IntercomProviderBase, useIntercom as useIntercomBase } from "react-use-intercom";
export function IntercomProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const isEnabled = useIsIntercomEnabled();
  let t1;
  if ($[0] !== children || $[1] !== isEnabled) {
    t1 = <IntercomProviderBase appId="rws4jyr5" shouldInitialize={isEnabled}>{children}</IntercomProviderBase>;
    $[0] = children;
    $[1] = isEnabled;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
const useIsIntercomEnabled = () => {
  const $ = _c(2);
  const [isEnabled, setIsEnabled] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsEnabled(window.location.hostname === "opensea.io");
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isEnabled;
};
export const useIntercom = () => {
  const $ = _c(3);
  const result = useIntercomBase();
  const isEnabled = useIsIntercomEnabled();
  let t0;
  if ($[0] !== isEnabled || $[1] !== result) {
    t0 = {
      ...result,
      isEnabled
    };
    $[0] = isEnabled;
    $[1] = result;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};